import type { CompanyConfig } from '@/pages/Companies/GetCompany/types/config'

export const CUSTOMER_AREA_PATH = '/area-do-cliente'

const isLocalHost = (host: string) => host === 'localhost' || host.endsWith('.localhost')

export function siteHost(config: Pick<CompanyConfig, 'urls'> | null | undefined): string | null {
  const entries = (config?.urls ?? []).flatMap(entry => {
    const url = typeof entry === 'string' ? entry : entry?.url
    return url ? [{ url, verified: typeof entry === 'string' ? false : !!entry.isVerified }] : []
  })
  return (entries.find(entry => entry.verified) ?? entries[0])?.url ?? null
}

export function customerAreaUrl(config: Pick<CompanyConfig, 'urls'> | null | undefined): string | null {
  const host = siteHost(config)
  if (!host) return null
  return `${isLocalHost(host) ? 'http' : 'https'}://${host}${CUSTOMER_AREA_PATH}`
}
